module.exports = __webpack_public_path__ + "static/media/expired.c364a229.svg";